import React from 'react';
import PropTypes from 'prop-types';

import * as passwordStrengthConstants from './passwordStrengthConstants';
import * as styleUtils from '../../../../utils/styleUtils';

import {SCORE_TO_PERCENTAGE} from './passwordStrengthConstants';

import {I18nMessage} from '../../I18n';

import styles from './PasswordStrength.scss';


function PasswordStrength({score}) {

    if (score === null) {

        return null;
    }

    const scoreClass = styles[`s-${score}`];
    const percentage = SCORE_TO_PERCENTAGE[score];

    return (

        <div className={styleUtils.toClasses(styles.passwordStrength, scoreClass)}>

            <strong>
                <I18nMessage id={'password.strength.label'}/>

                &nbsp;-&nbsp;

                <span className={styles.message}>
                    <I18nMessage id={`password.strength.${score}`}/>
                </span>
            </strong>

            <div className={styles.meter}>
                <div className={styles.progress}>
                    <span>
                        <I18nMessage
                            id={'password.strength.percentage'}
                            values={
                                {
                                    percentage
                                }
                            }
                        />
                    </span>
                </div>
            </div>

            <p>
                <strong>
                    <I18nMessage id={'password.strength.tip'}/>
                </strong>
                <I18nMessage id={'password.strength.info'}/>
            </p>

        </div>
    );
}


PasswordStrength.propTypes = {
    score: PropTypes.oneOf(passwordStrengthConstants.SCORES)
};


export default PasswordStrength;
